// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"49fb7b6c","467":"13cad4c3","802":"387aff09"}[chunkId] + ".chunk.css";
};